import PropTypes from 'prop-types';
import { getConfig } from '../config.js';

const parseJsonResponse = async (response) => {
	const text = await response.text();
	let payload = null;

	try {
		payload = text ? JSON.parse(text) : null;
	} catch (error) {
		throw new Error('Invalid response from server. Please try again.');
	}

	if (!payload) {
		throw new Error('Empty response from server. Please try again.');
	}

	if (!response.ok) {
		throw new Error(payload.message || `Server error (${response.status}). Please try again.`);
	}

	return payload;
};

export default async function apiServicewt(quary) {
	const webLink = getConfig().REACT_APP_WEB_LINK;
	let result;

	try {
		result = await fetch(webLink, {
			method: 'post',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify(quary),
		});
	} catch (error) {
		throw new Error('Network error. Please check your connection and try again.');
	}

	return parseJsonResponse(result);
}

apiServicewt.propTypes = {
	quary: PropTypes.isRequired,
	navigator: PropTypes.isRequired,
};
